<section>
    <div class="mainFrame">
    <div class="logoRow">
        <div class="logoBottom"><a href="#aboutTheFold"><img class="logoImage" 
            src="assets/logo/logo_ms_en_over.png" alt="logo" 
            srcset="" onmouseover="this.src='assets/logo/logo_ms_en.png'" 
            onmouseout="this.src='assets/logo/logo_ms_en_over.png'"></a>
        </div>
        <div class="copyright"><p>© Michael Spari 2025</p></div>
    </div>
    <div class="linkRow">
        <div class="legalNotice">
            <div class="legalNoticeText"><a routerLink="imprint">{{ 'imprint.imprint' | translate }}</a></div>
            <div class="legalNoticeOutLine"><img gitIcon src="assets/icon/nav/en_de_btn/B.1 3.png" alt="Legal Notice"></div>
        </div>
        <div class="gitHub">
            <button class="btnAnimation" onclick="window.location.href='https://github.com/Michael-Spari'">GitHub</button>
            <div class="gitCat"><img src="assets/icon/footer/gitCat.png"></div>
        </div>
        <div class="linkedIn">
            <button class="btnAnimation" onclick="window.location.href='https://www.linkedin.com/in/michael-spari-3541a3351'">LinkedIn</button>
            <div class="linked"><img src="assets/icon/footer/linkedin.png"></div>
            
        </div>
        <div class="email">
            <button class="btnAnimation" onclick="window.location.href='mailto:info@michaelspari.de'">Email</button>  
            <div class="gitCat"><img src="assets/icon/footer/mail.png"></div>           
        </div>
    </div>
    </div>
</section>
